import {
  initRoleCoaAccess,
  applyRoleCoaAccessFilter,
  normalizeAccountsLoadResponse,
  filterCollectionAccountsByRole,
  filterCoaListByRoleTree,
  filterJournalEntriesByCoaRights,
  buildCoaAccountIdsQueryParam,
  getRoleCoaRightsFromStore,
  getRoleAllowedCoaIds,
  isCoaAccessFeatureActive,
} from "@/utils/roleCoaAccess";

export default {
  data() {
    return {
      roleCoaAccessEnabled: false,
    };
  },
  methods: {
    async loadRoleCoaAccessSetting() {
      await initRoleCoaAccess(this);
    },
    normalizeAccountsResponse(response) {
      return normalizeAccountsLoadResponse(response);
    },
    filterAccountsByRole(list) {
      return applyRoleCoaAccessFilter(this, list);
    },
    /** Chart of accounts tree: allowed IDs + parent heads (+ descendants if head selected). */
    isCoaFilteringActive() {
      return isCoaAccessFeatureActive(this.$store, this);
    },
    filterAccountsByRoleTree(list, { includeDescendants = true } = {}) {
      if (!Array.isArray(list)) return list;
      if (!this.isCoaFilteringActive()) return list;
      return filterCoaListByRoleTree(
        list,
        getRoleCoaRightsFromStore(this.$store),
        { includeDescendants }
      );
    },
    filterCollectionAccountsByRole(list) {
      if (!Array.isArray(list)) return list;
      if (!this.isCoaFilteringActive()) return list;
      return filterCollectionAccountsByRole(
        list,
        getRoleCoaRightsFromStore(this.$store)
      );
    },
    filterJournalEntriesByRole(list) {
      return filterJournalEntriesByCoaRights(list, this.$store, this);
    },
    coaAccountIdsQueryParam() {
      return buildCoaAccountIdsQueryParam(this.$store, this);
    },
    hasCoaJournalRestriction() {
      return (
        this.isCoaFilteringActive() &&
        !!getRoleAllowedCoaIds(getRoleCoaRightsFromStore(this.$store))
      );
    },
  },
};
